define("shared/components/shared/card/header", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="o--cardHeader">
    {{#if @title}}
      <h2 class="o--cardHeader__title {{@titleClass}}">
        {{@title}}
      </h2>
    {{/if}}
    {{yield}}
  </div>
  */
  {
    "id": "Nl+qQu8k",
    "block": "[[[10,0],[14,0,\"o--cardHeader\"],[12],[1,\"\\n\"],[41,[30,1],[[[1,\"    \"],[10,\"h2\"],[15,0,[29,[\"o--cardHeader__title \",[30,2]]]],[12],[1,\"\\n      \"],[1,[30,1]],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[18,3,null],[1,\"\\n\"],[13]],[\"@title\",\"@titleClass\",\"&default\"],false,[\"if\",\"yield\"]]",
    "moduleName": "shared/components/shared/card/header.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});